/** Mirrors enums.Office (api/app/enums/office.go). */
export type Office =
  | "Long Beach Office"
  | "Fresno Office"
  | "Santa Maria Office"
  | "Santa Barbara Office"
  | "Chula Vista Office"
  | "San Luis Obispo Office"
  | "Bakersfield Office"
  | "Salinas Office"
  | "Visalia Office";

export const OFFICES: readonly Office[] = [
  "Long Beach Office",
  "Fresno Office",
  "Santa Maria Office",
  "Santa Barbara Office",
  "Chula Vista Office",
  "San Luis Obispo Office",
  "Bakersfield Office",
  "Salinas Office",
  "Visalia Office",
];
